module.exports = __webpack_public_path__ + "static/media/no-image.484f348a.png";